var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"50px","background-color":"#fff"}},[_c('HomeHeaderView'),_c('HomeBannerView'),_c('HomeMenuView'),_c('TmpAccount'),_c('HomeBorrowingView'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }